import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonComponent } from '../../../../../../shared/components/button/button.component';
import { ButtonTypeEnum } from '../../../../../../shared/components/button/types/button-type.enum';
import { SpinnerComponent } from '../../../../../../shared/components/spinner/spinner.component';
import { ButtonRadiusEnum } from '../../../../../../shared/components/button/types/button-radius.enum';

@Component({
  selector: 'app-finished',
  imports: [ButtonComponent, SpinnerComponent],
  templateUrl: './finished.component.html',
})
export class FinishedComponent {

  //#region Public Properties

  @Input({ required: true })
  public minimumScore: number = 0;

  @Input({ required: true })
  public userScore: number = 0;

  @Input({ required: true })
  public totalScore: number = 10;

  @Input({ required: true })
  public isLastModule: boolean = false;

  @Output()
  public restart: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  public nextModule: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  public certificate: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  public completeCourse: EventEmitter<void> = new EventEmitter<void>();

  @Input()
  public isLoading: boolean = false;

  @Input()
  public isCourseComplete: boolean = false;

  @Input()
  public passed: boolean | null = null;

  @Input()
  public resultMessage: string = '';

  public buttonTypeEnum: typeof ButtonTypeEnum = ButtonTypeEnum;

  public buttonRadiusEnum: typeof ButtonRadiusEnum = ButtonRadiusEnum;

  //#endregion

  //#region Getters

  public get hasPassed(): boolean {
    if (this.passed !== null) {
      return this.passed;
    }

    return this.userScore >= this.minimumScore;
  }

  public get resultText(): string {
    if (this.resultMessage) {
      return this.resultMessage;
    }

    return this.hasPassed ? 'Módulo concluído com sucesso!' : 'Nota mínima não atingida!';
  }

  public get scoreText(): string {
    return `${this.userScore.toFixed(1)} / ${this.totalScore}`;
  }

  //#endregion

  //#region Public Methods

  public restartModule(): void {
    this.restart.emit();
  }

  public goToNextModule(): void {
    this.nextModule.emit();
  }

  public finishCourse(): void {
    if (this.isLoading || this.isCourseComplete || !this.isLastModule || !this.hasPassed) {
      return;
    }

    this.completeCourse.emit();
  }

  public downloadCertificate(): void {
    this.certificate.emit();
  }

  //#endregion

}
